import PropTypes from "prop-types"
import ScrollButton from "../ScrollButton/ScrollButton"
// Styles
import {
   Container,
   Wrapper,
   Image,
   Text,
   Title,
} from "./PageSectionSplitHalf.styles"

const PageSectionSplitHalf = ({
   image,
   title,
   text,
   imageFirst,
   scrollContainer,
}) => {
   return (
      <Container>
         {imageFirst ? (
            <>
               <Image src={image} />
               <Wrapper>
                  <Title
                     dangerouslySetInnerHTML={{
                        __html: title?.replace(/\n/g, "<br />"),
                     }}
                  />
                  <Text
                     dangerouslySetInnerHTML={{
                        __html: text?.replace(/\n/g, "<br />"),
                     }}
                  />
               </Wrapper>
            </>
         ) : (
            <>
               <Wrapper>
                  <Title
                     dangerouslySetInnerHTML={{
                        __html: title?.replace(/\n/g, "<br />"),
                     }}
                  />
                  <Text
                     dangerouslySetInnerHTML={{
                        __html: text?.replace(/\n/g, "<br />"),
                     }}
                  />
               </Wrapper>
               <Image src={image} />
            </>
         )}
         <ScrollButton orientation="down" scrollContainer={scrollContainer} />
      </Container>
   )
}

PageSectionSplitHalf.propTypes = {
   image: PropTypes.string,
   title: PropTypes.string,
   text: PropTypes.string,
   imageFirst: PropTypes.bool,
   scrollContainer: PropTypes.object,
}

export default PageSectionSplitHalf
